export default "__VITE_ASSET__DLvEmbvQ__"